import React, { useState, useEffect, useRef, useCallback } from 'react';
// eslint-disable-next-line no-restricted-imports -- TODO: legacy connect (baseline)
import { connect } from 'react-redux';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

import { DateRangePickerConstant } from './date-range-picker-constants';
import {
    DateRangeFieldControls,
    DateRangeFieldWrapper,
    DaysPickerWrapper,
    DateRangeFieldControlReset,
    DayPickerWrapperBegin,
    DayPickerWrapperEnd,
    DateRangeFieldControlBegin,
    DateRangeFieldControlEnd,
    DateRangeFieldControlResetWrapper
} from './date-range-field-styled-components';
import FormattedMessage from '../formatted-message';
import { languageSelector } from '../../redux/modules/locale';
import { useOutsideClick } from '../../utils/hooks/use-outside-click';
import DeviceSelector from '../device-selector/device-selector';
import StyledModal from '../modal/styled-modal';

// eslint-disable-next-line no-restricted-syntax -- TODO: legacy function declaration (baseline)
function convertDayToDate(day) {
    const rawMM = day.getMonth() + 1;
    const rawDD = day.getDate();

    // eslint-disable-next-line no-restricted-syntax -- TODO: legacy function declaration (baseline)
    function formatDateTwoSymbol(partDate) {
        return partDate >= 10 ? partDate : `0${partDate}`;
    }

    const MM = '' + formatDateTwoSymbol(rawMM);
    const DD = '' + formatDateTwoSymbol(rawDD);
    const YYYY = day.getFullYear();

    return `${YYYY}-${MM}-${DD}`;
}

const DateRangeCustomStyles = {
    background: 'red'
};

/***
 * Will be render date picker and return on change date.
 * @param props
 * @returns {*}
 * {begin:  "YYYY-MM-DD", end: "YYYY-MM-DD" }
 */
// eslint-disable-next-line tpe/max-component-size -- TODO: legacy large component (baseline)
const DateRangeField = props => {
    const { value, leftPadding, firstDateSet, defaultCustomDate, customStartDate } = props;

    const [beginDate, setBeginDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [beginDatePickerIsVisible, setBeginDatePickerVisibility] = useState(false);
    const [endDatePickerIsVisible, setEndDatePickerVisibility] = useState(false);

    const [locale, setLocale] = useState('en');

    const [resetValue, setResetValue] = useState(false);

    useEffect(
        () => {
            const { onChange, path } = props;

            if (!onChange) {
                return;
            }

            if (!(beginDate === '' && endDate === '')) {
                onChange(path, { begin: beginDate, end: endDate });

                return;
            }

            if (!!firstDateSet && !resetValue) {
                onChange(path, { begin: defaultCustomDate, end: '' });

                return;
            }

            onChange(path, { begin: '', end: '' });
        },
        /*eslint-disable*/ [beginDate, endDate, defaultCustomDate] /*eslint-enable*/
    );

    useEffect(() => {
        setLocale(props.locale);
    }, [props.locale]);

    useEffect(() => {
        if (!resetValue) {
            return;
        }

        const resettableTimeout = setTimeout(() => {
            setResetValue(false);
        }, 250);

        return () => {
            clearTimeout(resettableTimeout);
            setResetValue(false);
        };
    }, [resetValue]);

    const handleChangeBeginDay = day => {
        const dateFromDay = convertDayToDate(day);

        setBeginDate(dateFromDay);

        setBeginDatePickerVisibility(false);
    };

    const handleChangeEndDay = day => {
        //todo check beginDate <= endDate and return this with notification

        const dateFromDay = convertDayToDate(day);

        setEndDate(dateFromDay);

        setEndDatePickerVisibility(false);
    };

    const handleDateBeginClick = () => {
        setBeginDatePickerVisibility(!beginDatePickerIsVisible);
        if (endDatePickerIsVisible && !beginDatePickerIsVisible) {
            setEndDatePickerVisibility(false);
        }
    };

    const handleDateEndClick = () => {
        if (endDatePickerIsVisible) {
            return;
        }
        setEndDatePickerVisibility(!endDatePickerIsVisible);
        if (!endDatePickerIsVisible && beginDatePickerIsVisible) {
            setBeginDatePickerVisibility(false);
        }
    };

    const handleResetTime = () => {
        setBeginDate('');
        setEndDate('');
        setBeginDatePickerVisibility(false);
        setEndDatePickerVisibility(false);
        setResetValue(true);
    };

    const transformDateToLocalView = dateRaw => {
        const year = dateRaw.slice(0, 4);
        const month = dateRaw.slice(5, 7);
        const day = dateRaw.slice(8);

        if (locale === 'ru') {
            return `${day}/${month}/${year}`;
        }

        return `${month}/${day}/${year}`;
    };

    const { path } = props;

    const { MONTHS, WEEKDAYS_SHORT, WEEKDAYS_LONG, FIRST_DAY_OF_WEEK, LABELS } = DateRangePickerConstant;

    const containerDayPickerBeginRef = useRef(null);
    const modalDayPickerBeginRef = useRef(null);
    const containerDayPickerEndRef = useRef(null);
    const modalDayPickerEndRef = useRef(null);

    // Each calendar closes on a press outside its field and its modal, and on a scroll of the page
    const closeBeginDatePicker = useCallback(() => setBeginDatePickerVisibility(false), []);
    const closeEndDatePicker = useCallback(() => setEndDatePickerVisibility(false), []);
    useOutsideClick({
        ref: [containerDayPickerBeginRef, modalDayPickerBeginRef],
        callback: closeBeginDatePicker,
        isEnabled: beginDatePickerIsVisible,
        closeOnScroll: true
    });
    useOutsideClick({
        ref: [containerDayPickerEndRef, modalDayPickerEndRef],
        callback: closeEndDatePicker,
        isEnabled: endDatePickerIsVisible,
        closeOnScroll: true
    });

    useEffect(() => {
        setBeginDate(value.begin || '');
        setEndDate(value.end || '');
    }, [value.begin, value.end]);

    const parsedBeginDate = beginDate ? new Date(beginDate) : undefined;
    const parsedEndDate = endDate ? new Date(endDate) : undefined;
    const parsedCustomDate = customStartDate ? new Date(customStartDate) : undefined;

    return (
        <DateRangeFieldWrapper>
            <DateRangeFieldControls>
                <DateRangeFieldControlBegin isActive={beginDatePickerIsVisible} onClick={handleDateBeginClick}>
                    {beginDate === '' ? (
                        <FormattedMessage id={'interface.calendar.begin'} />
                    ) : (
                        transformDateToLocalView(beginDate)
                    )}
                </DateRangeFieldControlBegin>
                <DateRangeFieldControlEnd isActive={endDatePickerIsVisible} onClick={handleDateEndClick}>
                    {endDate === '' ? (
                        <FormattedMessage id={'interface.calendar.end'} />
                    ) : (
                        transformDateToLocalView(endDate)
                    )}
                </DateRangeFieldControlEnd>
                {(beginDate !== '' || endDate !== '') && (
                    <DateRangeFieldControlResetWrapper>
                        <DateRangeFieldControlReset onClick={handleResetTime}>
                            <span>X</span>
                        </DateRangeFieldControlReset>
                    </DateRangeFieldControlResetWrapper>
                )}
            </DateRangeFieldControls>
            {!!(beginDatePickerIsVisible || endDatePickerIsVisible) && (
                <DaysPickerWrapper leftPadding={leftPadding}>
                    {!!beginDatePickerIsVisible && (
                        <DayPickerWrapperBegin ref={containerDayPickerBeginRef}>
                            <DeviceSelector
                                desktopLayout={
                                    <DayPicker
                                        month={parsedCustomDate || parsedBeginDate}
                                        selectedDays={parsedBeginDate}
                                        onDayClick={handleChangeBeginDay}
                                        locale={locale}
                                        months={MONTHS[locale]}
                                        weekdaysLong={WEEKDAYS_LONG[locale]}
                                        weekdaysShort={WEEKDAYS_SHORT[locale]}
                                        firstDayOfWeek={FIRST_DAY_OF_WEEK[locale]}
                                        labels={LABELS[locale]}
                                        key={`${path}-begin`}
                                        // eslint-disable-next-line tpe/no-inline-style -- TODO: legacy inline style (baseline)
                                        style={{ DateRangeCustomStyles: DateRangeCustomStyles }}
                                    />
                                }
                                mobileLayout={
                                    <StyledModal innerRef={modalDayPickerBeginRef} isOpen disableScroll>
                                        <DayPicker
                                            month={parsedBeginDate}
                                            selectedDays={parsedBeginDate}
                                            onDayClick={handleChangeBeginDay}
                                            locale={locale}
                                            months={MONTHS[locale]}
                                            weekdaysLong={WEEKDAYS_LONG[locale]}
                                            weekdaysShort={WEEKDAYS_SHORT[locale]}
                                            firstDayOfWeek={FIRST_DAY_OF_WEEK[locale]}
                                            labels={LABELS[locale]}
                                            key={`${path}-begin`}
                                            // eslint-disable-next-line tpe/no-inline-style -- TODO: legacy inline style (baseline)
                                            style={{ DateRangeCustomStyles: DateRangeCustomStyles }}
                                        />
                                    </StyledModal>
                                }
                            />
                        </DayPickerWrapperBegin>
                    )}

                    {!!endDatePickerIsVisible && (
                        <DayPickerWrapperEnd ref={containerDayPickerEndRef}>
                            <DeviceSelector
                                desktopLayout={
                                    <DayPicker
                                        month={parsedEndDate}
                                        selectedDays={parsedEndDate}
                                        onDayClick={handleChangeEndDay}
                                        locale={locale}
                                        months={MONTHS[locale]}
                                        weekdaysLong={WEEKDAYS_LONG[locale]}
                                        weekdaysShort={WEEKDAYS_SHORT[locale]}
                                        firstDayOfWeek={FIRST_DAY_OF_WEEK[locale]}
                                        labels={LABELS[locale]}
                                        key={`${path}-end`}
                                        // eslint-disable-next-line tpe/no-inline-style -- TODO: legacy inline style (baseline)
                                        style={{ DateRangeCustomStyles: DateRangeCustomStyles }}
                                    />
                                }
                                mobileLayout={
                                    <StyledModal innerRef={modalDayPickerEndRef} isOpen disableScroll>
                                        <DayPicker
                                            month={parsedEndDate}
                                            selectedDays={parsedEndDate}
                                            onDayClick={handleChangeEndDay}
                                            locale={locale}
                                            months={MONTHS[locale]}
                                            weekdaysLong={WEEKDAYS_LONG[locale]}
                                            weekdaysShort={WEEKDAYS_SHORT[locale]}
                                            firstDayOfWeek={FIRST_DAY_OF_WEEK[locale]}
                                            labels={LABELS[locale]}
                                            key={`${path}-end`}
                                            // eslint-disable-next-line tpe/no-inline-style -- TODO: legacy inline style (baseline)
                                            style={{ DateRangeCustomStyles: DateRangeCustomStyles }}
                                        />
                                    </StyledModal>
                                }
                            />
                        </DayPickerWrapperEnd>
                    )}
                </DaysPickerWrapper>
            )}
        </DateRangeFieldWrapper>
    );
};

const mapStateToProps = state => {
    return {
        locale: languageSelector(state)
    };
};

export default connect(mapStateToProps)(DateRangeField);
